import { createApp } from 'vue';
import AppMain from '@/app/components/AppMain.vue';
import { applyPlugins } from '@/app';
import type { App } from 'vue';

import './styles/index.css';
import '@axxone-system/hades/dist/styles/fonts.css';
import '@axxone-system/hades/dist/styles/base.css';
import '@axxone-system/hades/dist/styles/hades.css';
import '@axxone-system/hades/dist/styles/icons.css';
import consola from 'consola';
let vueAppPromise: Promise<App<Element>> | null = null;

async function initApp() {
    if (vueAppPromise) {
        return vueAppPromise;
    }

    const app = createApp(AppMain);
    applyPlugins(app);

    app.mount('#app');
    return app;
}

vueAppPromise = initApp().catch((error: unknown) => {
    consola.error('Error while mounting app:', error);
    throw error;
});

export default () => initApp();
